export class Code {
    code: string;
    shortDescription: string;
    longDescription: string;
}
